<template>
	<div class="flex-center pagination" v-if="lastPage > 1">
		<span class="page" @click="selectPage(currentPage - 1)">&#60;&#60;</span>

		<template v-if="currentPage !== firstPage">
			<span class="page" @click="selectPage(firstPage)" :class="{ active: currentPage === firstPage }">{{ firstPage }}</span>
		</template>

		<template v-if="currentPage-1 > firstPage">
			<span>...</span>
			<span class="page" @click="selectPage(currentPage-1)">{{ currentPage-1 }}</span>
		</template>

		<span class="page active" @click="selectPage(currentPage)">{{ currentPage }}</span>

		<template v-if="currentPage+1 < lastPage">
			<span class="page" @click="selectPage(currentPage+1)">{{ currentPage+1 }}</span>
			<span>...</span>
		</template>

		<template v-if="currentPage !== lastPage">
			<span class="page" @click="selectPage(lastPage)" :class="{ active: currentPage === lastPage }">{{ lastPage }}</span>
		</template>

		<span class="page" @click="selectPage(currentPage + 1)">&#62;&#62;</span>
	</div>
</template>

<script>
export default {
	props: {
		lastPage: {
			type: Number,
			default: 1
		},
		currentPage: {
			type: Number,
			default: 1
		}
	},

	data () {
		return {
			firstPage: 1,
			firstPageNumbers: [1, 2, 3]
		}
	},

	methods: {
		selectPage (page) {
			if (page < 1) return
			if (page > this.lastPage) return

			this.$emit('selectPage', page)
		}
	}
}
</script>

<style scoped>

.page {
	cursor: pointer;
	padding: 0 20px;
}

@media (max-width: 600px) {
	.page {
		padding: 0 10px;
	}
}




.page.active {
	font-weight: bold;
}

.pagination {
	margin: 20px auto;
}
</style>
